import { render, staticRenderFns } from "./SubtaskResourcesEditor.vue?vue&type=template&id=7281b5f8"
import script from "./SubtaskResourcesEditor.vue?vue&type=script&lang=js"
export * from "./SubtaskResourcesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports